<template>
  <div class="register">
    <h1>注册</h1>
    <el-tabs 
      v-model="activeName" 
      @tab-click="handleClick" 
      v-if="baseDefCount == 2"
      class="elTabsCss"
    >
      <el-tab-pane label="手机注册" name="phone"></el-tab-pane>
      <el-tab-pane label="邮箱注册" name="email"></el-tab-pane>
    </el-tabs>
    <el-form :model="ruleForm" :rules="formRules" ref="ruleForm" :validate-on-rule-change="false" class="demo-ruleForm">
      <!-- ----- 姓名 ----- -->
      <el-form-item label="姓名" prop="realName">
        <el-input v-model.trim="ruleForm.realName" placeholder="请输入注册考生的真实姓名"></el-input>
      </el-form-item>

      <!-- ----- 证件号 ----- -->
      <el-form-item label="证件号" prop="cardNo">
        <el-input placeholder="请输入正确的证件号" v-model="ruleForm.cardNo" class="input-with-select" @blur="cardNoBlur('ruleForm')">
          <el-select v-model="ruleForm.cardType" slot="prepend" placeholder="请选择">
            <el-option
              v-for="item in cardTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-input>
      </el-form-item>

      <!-- ----- 手机号 ----- -->
      <el-form-item label="手机号" prop="phone" v-if="activeName == 'phone'">
        <el-input v-model="ruleForm.phone" placeholder="请输入正确的手机号" @blur="phoneBlur('ruleForm')"></el-input>
      </el-form-item>

      <!-- ----- 手机验证码 ----- -->
      <el-form-item label="手机验证码" prop="checkCode" v-if="isOpenPhoneLogin && activeName == 'phone'" style="position:relative;">
        <el-input
          v-model="ruleForm.checkCode"
          placeholder="请输入手机验证码"
        ></el-input>
        <div :class="[isgetCode ? 'isgetCode' : 'getCode']" @click="[isgetCode ? getVerCode(ruleForm.phone) : '']">
            {{countDownText}}
        </div>
      </el-form-item>

      <!-- ----- 邮箱 ----- -->
      <el-form-item label="邮箱" prop="email" v-if="activeName == 'email'">
        <el-input v-model="ruleForm.email" placeholder="请输入正确的邮箱" @blur="emailBlur('ruleForm')"></el-input>
      </el-form-item>

      <!-- ----- 邮箱验证码 ----- -->
      <el-form-item label="邮箱验证码" prop="checkCode4Email" v-if="isOpenPhoneLogin && activeName == 'email'" style="position:relative;">
        <el-input
          v-model="ruleForm.checkCode4Email"
          placeholder="请输入邮箱验证码"
        ></el-input>
        <div :class="[isgetCode4Email ? 'isgetCode' : 'getCode']" @click="[isgetCode4Email ? getVerCode4Email(ruleForm.email) : '']">
            {{countDownText4Email}}
        </div>
      </el-form-item>

      <!-- ----- 一次密码 ----- -->
      <el-form-item label="设置密码" prop="password">
        <el-input
          v-model.trim="ruleForm.password"
          type="password"
          autocomplete="new-password"
          placeholder="请输入密码"
        ></el-input>
        <ots-password-tooltip></ots-password-tooltip>
      </el-form-item>

      <!-- ----- 二次密码 ----- -->
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input
          v-model.trim="ruleForm.confirmPassword"
          type="password"
          autocomplete="new-password"
          placeholder="设置密码和确认密码必须相同"
        ></el-input>
      </el-form-item>
 
      <!-- ----- 按钮 ----- -->
      <el-form-item class="registerBtn">
        <el-button type="primary" @click="handleRegister('ruleForm')">注 册</el-button>
      </el-form-item>
      <div class="registerBot"><span @click="backLogin">返回登录</span></div>
    </el-form>

  </div>
</template>

<script>

import { checkPwd, checkCardId, checkPhone, passWordStrength} from "@/common/verify.js";
import { isgetTenantSmsConfig } from '@/http/modules/notice/notice'
/* 这周短信模块不需要配合测试的话、、、等注册完事儿。今天开会说的那个table组件 列表隐藏可以研究下、、、 这个别的项目有例子、你弄的时候可以发你参考、、、这周差不多就这样了、、 */
export default {
  data() {
    return {
      // 是否开启手机验证码获取表单
      isOpenPhoneLogin: false,
      // 是否开启验证码按钮
      isgetCode: false,
      isgetCode4Email: false,
      // 按钮文字
      countDownText: "获取验证码",
      countDownText4Email: "获取验证码",
      // 距离再次获取验证码的剩余秒数
      count: 120,
      count4Email: 120,
      cardTypeList: [
        {
          id: "1",
          name: "身份证",
        },
        {
          id: "2",
          name: "护照",
        },
        {
          id: "3",
          name: "士官证",
        },
        {
          id: "4",
          name: "港澳台身份证",
        },
      ],
      ruleForm: {
        realName: "",
        cardNo: "",
        cardType: "1",
        phone: "",
        // 手机验证码
        checkCode: "",
        email: "",
        checkCode4Email: "",
        password: "",
        confirmPassword: "",
        tenant: this.$route.query.tenant ? this.$route.query.tenant : "",
      },
      baseDefCount: 0, //如果是2，则显示上面的页签，否则不显示
      requiredList: [],
      activeName: ''
    };
  },
  watch: {
    $route: {
      handler: function () {
        if (this.$route.query.tenant) {
          this.ruleForm.tenant = this.$route.query.tenant;
        } else {
          this.ruleForm.tenant = "";
        }
      },
      immediate: true,
    },
  },
  created(){
    // 获取内存的倒计时
    let myEndTime = localStorage.getItem("myEndTime");
    myEndTime && this.codeCountDown(myEndTime);
    let myEndTime4Email = localStorage.getItem("myEndTime4Email");
    myEndTime4Email && this.codeCountDown4Email(myEndTime4Email);
    // 是否开启验证码功能
    this.isOpenPhoneVcode();
    this.getBaseDefList();
  },
  computed: {
    formRules() {
      const nowPhone = this.activeName === 'phone';
      const nowEmail = this.activeName === 'email';
      let rules = {
        realName: [
          {
            required: true,
            message: "请输入注册考生的真实姓名",
            trigger: "blur",
          },
        ],
        cardNo: [
          { required: true, message: "请输入证件号", trigger: "blur" },
          {
            message: "身份证格式错误",
            trigger: "blur",
            validator: this.checkCardId,
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: passWordStrength, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: this.confirmPassword, trigger: "blur" },
        ]
      }

      if(nowPhone){
        rules.phone = [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { message: "手机号格式错误", trigger: "blur", validator: checkPhone },
        ]
      }

      if(nowPhone && this.isOpenPhoneLogin){
        rules.checkCode = [
          { required: true, message: "请输入手机验证码", trigger: "blur"},
        ]
      }

      if(nowEmail){
        rules.email = [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { message: "邮箱格式错误", trigger: "blur", type: "email" },
        ]
      }

      if(nowEmail && this.isOpenPhoneLogin){
        rules.checkCode4Email = [
          { required: true, message: "请输入邮箱证码", trigger: "blur"},
        ]
      }

      return rules;
    }
  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.label == '手机注册' ? 'phone' : 'email';
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate()
      })
    },
    /*************************
     * @this 获取手机和邮箱的相关设置
     *************************/
    getBaseDefList() {
      let params = this.$route.query.tenant;
      this.$api.system.getSystemNameFN({ tenant: params }).then((res) => {
        if(res.code == 1){
          this.baseDefCount = res.data.baseDefList
            .filter(item => item.fieldName == 'phone' || item.fieldName == 'email')
            .filter(item => item.required == 1)
            .length;
          this.requiredList = res.data.baseDefList.filter(item => item.required == 1).map(item => item.fieldName);
          this.activeName = this.requiredList.includes('phone') ? 'phone' : 'email';
        }else{
          this.$router.push({
            name: "Login",
            query: { tenant: this.ruleForm.tenant },
          });
        }
      });
    },
    /*************************
     * @this 是否开启手机验证码登录功能
     *************************/
    isOpenPhoneVcode(){
        let tenant = this.$route.query.tenant;
        isgetTenantSmsConfig({tenant}).then(res => {
            if(res.code == 1){
                if(res.data.registCheck == 1){
                  this.isOpenPhoneLogin = true;
                } else {
                  this.isOpenPhoneLogin = false;
                }
            } else {
              this.isOpenPhoneLogin = false;
            }
        })
    },

    /*************************
     * @this 获取手机验证码
     *************************/
    getVerCode(state){
      // 判断姓名,手机号,证件号是否填写完成
      let { realName, cardNo, phone } = this.ruleForm;
      // 1.判断验证码功能是否开启，调用接口
      if (realName && cardNo && phone) {
          // 2.发送验证码
          let type = 0;
          let { phone, tenant } = this.ruleForm;
          this.$api.login.phoneCheckCode({ phone, type, tenant,email:'' }).then((res) => {
            // 3.成功发送验证码后,设置获取验证码倒计时
            if (res.code == 1) {
              this.GetCode();
            }
          });
      } else {
          this.$message.error("请将注册信息填写完整！");
          this.isgetCode = false;
          return false;
      }
    },
    /*************************
     * @this 获取邮箱验证码
     *************************/
    getVerCode4Email(state){
      // 判断姓名,邮箱,证件号是否填写完成
      let { realName, cardNo, email } = this.ruleForm;
      // 1.判断验证码功能是否开启，调用接口
      if (realName && cardNo && email) {
          // 2.发送验证码
          let type = 0;
          let { email, tenant } = this.ruleForm;
          this.$api.login.phoneCheckCode({ email, type, tenant, phone:'' }).then((res) => {
            // 3.成功发送验证码后,设置获取验证码倒计时
            if (res.code == 1) {
              this.GetCode4Email();
            }
          });
      } else {
          this.$message.error("请将注册信息填写完整！");
          this.isgetCode4Email = false;
          return false;
      }
    },

    /*************************
     * @this 倒计时存入缓存,防止刷新重置
     *************************/
    GetCode() {
        let endMsRes = new Date().getTime() + 120000;
        localStorage.setItem("myEndTime", JSON.stringify(endMsRes));
        this.codeCountDown(endMsRes);
    },
    /*************************
     * @this 倒计时存入缓存,防止刷新重置
     *************************/
    GetCode4Email() {
        let endMsRes = new Date().getTime() + 120000;
        localStorage.setItem("myEndTime4Email", JSON.stringify(endMsRes));
        this.codeCountDown4Email(endMsRes);
    },

    /*************************
     * @this 倒计时计算,清除缓存和定时器
     *************************/
    codeCountDown(endMsRes) {
        this.isgetCode = false;
        this.countDownText = this.count + "秒后获取";
        this.count = Math.ceil((endMsRes - new Date().getTime()) / 1000);
        let time = setTimeout(() => {
            this.count--;
            if (this.count < 1) {
                this.isgetCode = true;
                this.countDownText = "获取验证码";
                this.count = 120;
                localStorage.removeItem("myEndTime");
                clearTimeout(time);
            } else {
                this.codeCountDown(endMsRes);
            }
        }, 1000);
    },

    /*************************
     * @this 倒计时计算,清除缓存和定时器
     *************************/
    codeCountDown4Email(endMsRes) {
        this.isgetCode4Email = false;
        this.countDownText4Email = this.count4Email + "秒后获取";
        this.count4Email = Math.ceil((endMsRes - new Date().getTime()) / 1000);
        let time = setTimeout(() => {
            this.count4Email--;
            if (this.count4Email < 1) {
                this.isgetCode4Email = true;
                this.countDownText4Email = "获取验证码";
                this.count4Email = 120;
                localStorage.removeItem("myEndTime4Email");
                clearTimeout(time);
            } else {
                this.codeCountDown4Email(endMsRes);
            }
        }, 1000);
    },

    /*************************
     * @this 验证身份证格式
     *************************/
    checkCardId(rule, value, callback) {
      return checkCardId(rule, value, callback, this.ruleForm.cardType);
    },

    /*************************
     * @this 返回登录
     *************************/
    backLogin() {
      this.$router.push({
        name: "Login",
        query: { tenant: this.ruleForm.tenant },
      });
    },

    /*************************
     * @this 确认密码
     *************************/
    confirmPassword(rule, value, callback) {
      if (value) {
        if (this.ruleForm.password !== this.ruleForm.confirmPassword) {
          callback(new Error("设置密码和确认密码必须相同"));
        } else {
          callback();
        }
      }
      callback();
    },

    /*************************
     * @this 账号范围验证接口,不清空表单
     *************************/
    verification(queryCheckd,inputName) {
      this.$api.login.verification(queryCheckd).then((res) => {
        if (res.code === 0 ) {
          if(inputName == 'phone'){
            this.isgetCode = false;
          }else{
            this.isgetCode4Email = false;
          }
        } else if(res.code === 1) {
          if(inputName == 'phone'){
            this.isgetCode = true;
          }else{
            this.isgetCode4Email = true;
          }
        }
      });
    },

    /*************************
     * @this 手机号输入表单失焦事件
     *************************/
    phoneBlur(formName) {
      let { cardNo, phone, tenant, email = '' } = this.ruleForm;
      let queryCheckd = { cardNo, phone, email, tenant };
      if (!cardNo && phone) {
        this.$confirm("请先输入证件号进行考生范围验证", "系统提示", {
          confirmButtonText: "确定",
          roundButton: true,
        });
        return;
      }
      this.$refs[formName].validateField(["phone"], (valid) => {
        if(!valid){
          if (cardNo && phone) {
            this.verification(queryCheckd,'phone');
          }
        } else {
          this.isgetCode = false;
        }
      });
    },
    /*************************
     * @this 邮箱输入表单失焦事件
     *************************/
    emailBlur(formName) {
      let { cardNo, phone = '', tenant, email } = this.ruleForm;
      let queryCheckd = { cardNo, phone, email, tenant };
      if (!cardNo && email) {
        this.$confirm("请先输入证件号进行考生范围验证", "系统提示", {
          confirmButtonText: "确定",
          roundButton: true,
        });
        return;
      }
      this.$refs[formName].validateField(["email"], (valid) => {
        if(!valid){
          if (cardNo && email) {
            this.verification(queryCheckd,'email');
          }
        } else {
          this.isgetCode4Email = false;
        }
      });
    },

    /*************************
     * @this 考生范围验证,证件号
     *************************/
    cardNoBlur(formName) {
      let { cardNo, phone, email, tenant } = this.ruleForm;
      let queryCheckd = { cardNo, phone, tenant, email:'' };
      let queryCheckd4Email = { cardNo, email, tenant, phone:'' };
      if(this.activeName=='phone'){
        this.$refs[formName].validateField(["phone"], (valid) => {
          if(!valid){
            if (cardNo && phone) {
              this.verification(queryCheckd,'phone');
            } else {
              this.isgetCode = false;
            }
          } else {
            this.isgetCode = false;
          }
        });
      }else{
        this.$refs[formName].validateField(["email"], (valid) => {
          if(!valid){
            if (cardNo && email) {
              this.verification(queryCheckd4Email,'email');
            } else {
              this.isgetCode4Email = false;
            }
          } else {
            this.isgetCode4Email = false;
          }
        });
      }
    },

    /*************************
     * @this 注册
     *************************/
    handleRegister(formName) {
      let { cardNo, phone, email, tenant } = this.ruleForm;
      let queryCheckd = { cardNo, phone, tenant, email:'' };
      let queryCheckd4Email = { cardNo, email, tenant, phone:'' };
      if(this.activeName=='phone'){
        // 再次验证手机号,证件号是否被使用过
        this.$api.login.verification(queryCheckd,'phone').then((res) => {
          if (res.code === 0 ) {
            this.isgetCode = false;
          } else if(res.code === 1) {
            this.isgetCode = true;
            this.$refs[formName].validate((valid) => {
              if (valid) {
                this.ruleForm.email = '';
                this.ruleForm.checkCode4Email = '';
                this.$api.applyManage.registerUser(this.ruleForm).then((res) => {
                  if (res.code) {
                    this.$message({
                      message: "注册成功,请登录",
                      type: "success",
                    });
                    this.$router.push({
                      name: "Login",
                      query: { tenant: this.ruleForm.tenant },
                    });
                  }
                });
              }
            });
          }
        });
      }else{
        // 再次验证邮箱,证件号是否被使用过
        this.$api.login.verification(queryCheckd4Email,'email').then((res) => {
          if (res.code === 0 ) {
            this.isgetCode4Email = false;
          } else if(res.code === 1) {
            this.isgetCode4Email = true;
            this.$refs[formName].validate((valid) => {
              if (valid) {
                this.ruleForm.phone = '';
                this.ruleForm.checkCode = this.ruleForm.checkCode4Email; //因为接口就一个验证码，所以如果是邮箱注册，就把邮箱验证码给手机验证码
                this.ruleForm.checkCode4Email = '';
                this.$api.applyManage.registerUser(this.ruleForm).then((res) => {
                  if (res.code) {
                    this.$message({
                      message: "注册成功,请登录",
                      type: "success",
                    });
                    this.$router.push({
                      name: "Login",
                      query: { tenant: this.ruleForm.tenant },
                    });
                  }
                });
              }
            });
          }
        });
      }
    },

    /*************************
     * @this 重置
     *************************/
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

  },
};
</script>

<style lang="less" scoped>
.elTabsCss{
  width:360px; 
  margin:0 auto; 
  margin-bottom: 10px;
}
.register {
  background: rgba(255, 255, 255, 0.95);
  width: 100%;
  padding: 32px 48px 40px 48px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 8px;
  text-align: center;
  backdrop-filter: blur(10px);
  h1 {
    font-size: 20px;
    font-weight: 600;
    color: #2d2f33;
    padding-bottom: 16px;
    border-bottom: 1px solid #dadde6;
    margin-bottom: 40px;
    text-align: left;
  }
  .demo-ruleForm {
    display: inline-block;
    /* ***** 获取验证码按钮样式 ***** */
    .isgetCode {
        text-align: right;
        font-size: 14px;
        line-height: 40px;
        width: 84px;
        height: 40px;
        position: absolute;
        right: 12px;
        top: 22px;
        color: #006aff;
        cursor: pointer;
    }
    .getCode {
        text-align: right;
        font-size: 14px;
        line-height: 40px;
        width: 84px;
        height: 40px;
        position: absolute;
        right: 12px;
        top: 22px;
        color: #9299a6;
        cursor: not-allowed;
    }
    .el-form-item {
      margin-bottom: 24px !important;
      /deep/ .el-form-item__label {
        line-height: 1;
        margin-bottom: 8px;
      }
      /deep/ .el-input {
        width: auto;
      }
      /deep/ .el-input__inner {
        width: 360px;
        height: 40px;
      }
      .input-with-select {
        /deep/ .el-input-group__prepend {
          margin-right: 24px !important;
        }
        .el-select {
          /deep/ .el-input__inner {
            width: 116px !important;
            margin-left: 0;
            background: #fff;
          }
        }
        /deep/ .el-input__inner {
          width: 240px !important;
          margin-left: 4px;
        }
      }
    }
  }

  .registerBtn {
    margin-top: 32px;
    margin-bottom: 24px;
    /deep/ .el-button--primary {
      span {
        font-size: 16px;
      }
      background-color: #006aff;
      width: 100%;
      height: 40px;
      border-radius: 24px;
    }
  }
  .registerBot {
    text-align: center;
    color: #9299a6;
    font-size: 14px;
    span {
      color: #006aff;
      cursor: pointer;
    }
  }
}
/* 2021/11/26 IE 表单样式问题(盒模型大小同谷歌有异) */
/deep/ .el-input .el-input__inner {
  width: 240px;
  height: 36px;
  line-height: 18px;
}
/* IE~ */
/deep/ .el-form{
  width:360px\0;
}
</style>
